import { Component } from "react";
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Masonry from '@mui/lab/Masonry';
import Paper from '@mui/material/Paper';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { Trans } from "react-i18next";
import CatalogItemImage from "./CatalogItemImage";

type Props = {
    catalog: any[],
    addToCatalog: any,
    expanded: Set<number>,
    handleExpanded: any
};

type State = {
}


export default class extends Component<Props, State> {

  constructor(props: Props) {
    super(props)

  }


  render() {
    return (
      <Box
        sx={{
          maxWidth: "1230px",
          margin: { xs: "0 10%", sm: "0 10%", lg: "0 10%", xl: "0 auto" },
        }}
      >
        <Masonry
          columns={{ xs: 1, sm: 2, md: 3, lg: 4, xl: 4 }}
          spacing={2}
          sx={{ alignContent: "flex-start" }}
        >
          {this.props.catalog?.map((catalogItem, index) => (
            <Paper
              key={index}
              className="catalog-item-paper"
              elevation={this.props.expanded.has(index) ? 6 : 3}
              sx={{
                position: 'relative',
              }}
            >

              <Box
                sx={{
                  display: "flex",
                  alignItems: "flex-end",
                  justifyContent: "flex-end",
                  mt: 1,
                  height:'37px',
                  position: 'absolute',
                  right: 0
                }}
              >
                {catalogItem.novelty && (
                  <Chip
                    key={index}
                    label={<Trans i18nKey={`models.carClassifications.labels.NOVELTY`}></Trans>}
                    size="small"
                    className="catalog-chip-novelty-tag"

                  />
                )}
              </Box>


              <CatalogItemImage catalogItem={catalogItem} />
              <Accordion
                expanded={this.props.expanded.has(index)}
                className="catalog-item-paper"
                sx={{background: catalogItem.novelty?'#103115': '#EDF3E2'}}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon  style={{ color: catalogItem.novelty? 'white':'back' }} />}
                  onClick={() => this.props.handleExpanded(index)}
                  className="catalog-item-summary"
                >
                  <Box className= {catalogItem.novelty? "catalog-item-title-novelty" :"catalog-item-title"}>
                    {catalogItem.model}
                  </Box>
                </AccordionSummary>
                <AccordionDetails className="catalog-item-detail">
                  <Box sx={{ display: "flex" }}>
                    <Box className= { catalogItem.novelty? "catalog-item-data novelty":"catalog-item-data " }>Marca</Box>
                    <Box className= { catalogItem.novelty? "catalog-item-data novelty value":"catalog-item-data value" }>
                      {catalogItem.brand}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex" }}>
                    <Box className= { catalogItem.novelty? "catalog-item-data novelty":"catalog-item-data " }>Tipo de unidad</Box>
                    <Box className= { catalogItem.novelty? "catalog-item-data novelty value":"catalog-item-data value" }>
                      <Trans
                        i18nKey={`models.carClassifications.labels.${catalogItem.carClassification}`}
                      ></Trans>
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex" }}>
                    <Box className= { catalogItem.novelty? "catalog-item-data novelty":"catalog-item-data " }>
                      Capacidad de carga
                    </Box>
                    <Box className= { catalogItem.novelty? "catalog-item-data novelty value":"catalog-item-data value" }>
                      {catalogItem.loadingCapacity}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex" }}>
                    <Box className= { catalogItem.novelty? "catalog-item-data novelty":"catalog-item-data " }>Número de puertas</Box>
                    <Box className= { catalogItem.novelty? "catalog-item-data novelty value":"catalog-item-data value" }>
                      {catalogItem.numberOfDoors}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex" }}>
                    <Box className= { catalogItem.novelty? "catalog-item-data novelty":"catalog-item-data " }>Transmisión</Box>
                    <Box className= { catalogItem.novelty? "catalog-item-data novelty value":"catalog-item-data value" }>
                      {catalogItem.typeOfTransmission}
                    </Box>
                  </Box>
                  <Box sx={{ display: "flex" }}>
                    <Box className= { catalogItem.novelty? "catalog-item-data novelty":"catalog-item-data " }>Aire Condicionado</Box>
                    <Box className= { catalogItem.novelty? "catalog-item-data novelty value":"catalog-item-data value" }>
                      {catalogItem.airConditioning ? 'Si' : 'No'}
                    </Box>
                  </Box>
                </AccordionDetails>
              </Accordion>
            </Paper>
          ))}
        </Masonry>
      </Box>
    );
  }
}
